import { AsYouType, isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

import type { CountryCode } from 'libphonenumber-js';

/**
 * Страна по умолчанию для парсинга/валидации номеров без явного префикса `+CC`.
 *
 * Если пользователь начинает ввод с `+`, libphonenumber определяет страну
 * сам и эту константу игнорирует. UZ выбран как основная юрисдикция проекта.
 */
export const DEFAULT_PHONE_COUNTRY: CountryCode = 'UZ';

/**
 * Форматирует номер по правилам страны прямо во время ввода (as-you-type).
 *
 * Каждый вызов создаёт новый stateful-форматтер и прогоняет всю строку
 * с нуля — это нужно, чтобы корректно обрабатывать удаление символов
 * посередине и вставку из буфера.
 *
 * @param input строка, как её ввёл пользователь
 * @param country код страны по умолчанию (если в input нет `+CC`)
 * @returns отформатированная строка (`+998 90 123 45 67`)
 */
export function formatPhoneAsYouType(
  input: string,
  country: CountryCode = DEFAULT_PHONE_COUNTRY,
): string {
  return new AsYouType(country).input(input);
}

/**
 * Конвертирует пользовательский ввод в строгий E.164.
 *
 * @returns E.164-строку (`+79991234567`) или `null`, если номер не валиден
 */
export function toE164(input: string, country: CountryCode = DEFAULT_PHONE_COUNTRY): string | null {
  const parsed = parsePhoneNumberFromString(input, country);
  return parsed?.isValid() ? parsed.format('E.164') : null;
}

/**
 * Проверяет, валиден ли номер для указанной страны (или для угаданной
 * по `+CC`-префиксу). Используется в Form.Item-валидаторе.
 */
export function isPhoneValid(input: string, country: CountryCode = DEFAULT_PHONE_COUNTRY): boolean {
  if (!input) return false;
  return isValidPhoneNumber(input, country);
}
